import { InputAdornment } from '@mui/material';
import styled from 'styled-components';

import { COLORS } from 'theme';

export const StyledInputAdornment = styled(InputAdornment)`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.s1};
  color: ${COLORS.black50};
`;
